<template>
  <v-layout>
    <v-app-bar elevation="0" class="border-b px-4">
      <v-app-bar-nav-icon
        variant="text"
        @click.stop="drawer = !drawer"
        class="mx-0"
      ></v-app-bar-nav-icon>
      <v-toolbar-title @click="navigateTo('/pembelajaran-wajib')">
        <v-img height="48px" width="106px" src="/images/logo.png"
      /></v-toolbar-title>
      <v-spacer></v-spacer>
      <template v-if="$vuetify.display.mdAndUp">
        <AccountBelajarWajib />
        <v-menu width="254">
          <template v-slot:activator="{ props }">
            <v-btn
              icon="mdi-chevron-down"
              variant="text"
              v-bind="props"
            ></v-btn>
          </template>
          <v-list>
            <v-list-item title="Keluar" @click="logoutBelajarWajib">
              <template v-slot:prepend>
                <v-icon icon="mdi-logout"></v-icon>
              </template>
            </v-list-item>
          </v-list>
        </v-menu>
      </template>
      <v-menu v-else width="254">
        <template v-slot:activator="{ props }">
          <v-btn icon="mdi-dots-vertical" variant="text" v-bind="props"></v-btn>
        </template>
        <v-list>
          <AccountBelajarWajib class="mb-2" />
          <v-divider></v-divider>
          <v-list-item title="Keluar" @click="logoutBelajarWajib">
            <template v-slot:prepend>
              <v-icon icon="mdi-logout"></v-icon>
            </template>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar>
    <v-navigation-drawer
      v-model="drawer"
      :location="$vuetify.display.mobile ? 'bottom' : 'left'"
      class="border-0 bg-white pt-4"
      width="300"
      elevation="3"
    >
      <v-list color="red-darken-4" class="mb-4">
        <v-list-item
          v-for="(link, linkId) in navbarLink"
          :key="linkId"
          :prepend-icon="link.icon"
          :title="link.name"
          :to="`${link.to}?batchId=${batchId}`"
          class="px-7"
        ></v-list-item>
      </v-list>
      <template v-slot:append>
        <v-divider></v-divider>
        <div class="text-center pa-2 text-caption">
          Portal Pembelajaran Wajib
          <div class="text-medium-emphasis">
            Lembaga Administrasi Negara — {{ new Date().getFullYear() }}
          </div>
        </div>
      </template>
    </v-navigation-drawer>
    <v-main class="bg-grey-lighten-5">
      <v-container
        fluid
        class="px-4 px-md-8"
        style="min-height: calc(var(--vh, 1vh) * 100)"
      >
        <v-row>
          <BreadcrumsBelajarWajib />
          <div class="w-100">
            <DeadlineNotifications v-if="tugas?.length" :tugas="tugas" />
          </div>
          <NuxtPage />
        </v-row>
      </v-container>
    </v-main>
  </v-layout>
</template>
<script>
import BreadcrumsBelajarWajib from "~/components/pembelajaran_wajib/shared/BreadcrumsBelajarWajib";
import AccountBelajarWajib from "~/components/pembelajaran_wajib/shared/AccountBelajarWajib";
import DeadlineNotifications from "~/components/pembelajaran_wajib/terjadwal/DeadlineNotifications";

export default {
  components: {
    BreadcrumsBelajarWajib,
    AccountBelajarWajib,
    DeadlineNotifications,
  },
  data: () => ({
    drawer: null,
    navbarLink: [
      {
        name: "Dashboard",
        to: "/pembelajaran-wajib/terjadwal",
        icon: "mdi-view-dashboard-outline",
      },
      {
        name: "Agenda Pembelajaran",
        to: "/pembelajaran-wajib/terjadwal/agenda",
        icon: "mdi-view-agenda-outline",
      },
      {
        name: "Quiz",
        to: "/pembelajaran-wajib/terjadwal/quiz",
        icon: "mdi-comment-question-outline",
      },
      {
        name: "Proyek Perubahan",
        to: "/pembelajaran-wajib/terjadwal/proyek-perubahan",
        icon: "mdi-lightbulb-outline",
      },
      {
        name: "Evaluasi Akademik",
        to: "/pembelajaran-wajib/terjadwal/evaluasi-akademik",
        icon: "mdi-school-outline",
      },
      {
        name: "Profil Peserta",
        to: "/pembelajaran-wajib/terjadwal/profil",
        icon: "mdi-account",
      },
    ],
    tugas: [],
  }),
  computed: {
    batchId() {
      return useRoute().query.batchId;
    },
    courseDetail() {
      return useBelajarWajibTerjadwalStore().courseDetail;
    },
  },
  watch: {
    courseDetail: {
      immediate: true,
      async handler(_) {
        return this.fetchTugas();
      },
    },
  },
  methods: {
    logoutBelajarWajib() {
      useBelajarWajibStore().clearTokens();
      return navigateTo({ path: "/pembelajaran-wajib/login" });
    },
    getGroup(aktifitasGuid) {
      return useBelajarWajibTerjadwalStore().getKelompok(aktifitasGuid);
    },
    getDetailTugas(aktifitasGuid) {
      return useBelajarWajibTerjadwalStore().getDetailTugas(aktifitasGuid);
    },
    async fetchTugas() {
      const tasksInOneWeek = this.courseDetail.aktifitasList?.filter(
        (aktifitas) => {
          if (aktifitas.aktivityType === "TUGAS") {
            const now = new Date();
            const endDate = new Date(aktifitas.end);
            const oneWeekFromNow = new Date();
            oneWeekFromNow.setDate(now.getDate() + 7);
            if (endDate >= now && endDate <= oneWeekFromNow) {
              return aktifitas;
            }
          }
        }
      );
      if (tasksInOneWeek) {
        const promises = tasksInOneWeek.map((aktifitas, index) => {
          if (aktifitas.haveWorkingGroup) {
            return this.getGroup(aktifitas.guid).catch((error) => ({
              error,
              index,
            }));
          } else {
            return this.getDetailTugas(aktifitas.guid).catch((error) => ({
              error,
              index,
            }));
          }
        });
        const hasErrors = await Promise.all(promises).then((results) => {
          const errors = results
            .map((result, i) => {
              if (!result?.guid || !result?.tugasLink) {
                return i;
              }
            })
            .filter((i) => i >= 0);
          return errors;
        });
        this.tugas = tasksInOneWeek.filter((_, index) =>
          hasErrors.includes(index)
        );
      }
    },
  },
};
</script>
